import firebase from '../../components/firebaseInit'

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
  storeFeedback: ({commit}, formData) => {
    return new Promise((resolve, reject) => {
      firebase.firestore().collection('contact').add({
        email: formData.email,
        name: formData.name,
        subject: formData.subject,
        message: formData.message
      }).then(function (docRef) {
        resolve(docRef)
      }).catch(function (error) {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/vuex/module/contact.js